<template>
  <va-card :title="$t('menu.statuses')">
    <va-data-table
      :fields="fields"
      :data="statuses"
      :per-page="50"
    >
      <!-- <template slot="actions" slot-scope="props">
        <va-popover :message="getStarMessage(props.rowData)" placement="top">
          <va-button
            flat small
            :color="getStarColor(props.rowData)"
            icon="fa fa-star"
            @click="star(props.rowData)"
          />
        </va-popover>

        <va-popover :message="`${$t('tables.edit')} ${props.rowData.fullName}`" placement="top">
          <va-button flat small color="gray" icon="fa fa-pencil" />
        </va-popover>

        <va-popover :message="`${$t('tables.delete')} ${props.rowData.fullName}`" placement="top">
          <va-button flat small color="gray" icon="fa fa-trash" />
        </va-popover>
      </template> -->
    </va-data-table>
  </va-card>
</template>

<script>

import StatusAPI from '@/services/StatusAPI'

export default {
  data () {
    return {
      statuses: [],
    }
  },
  mounted () {
    StatusAPI.getAllStatuses().then(response => {
      this.statuses = response.data.statuses
    })
  },
  computed: {
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.statuses.id'),
        width: '10%',
      },
      {
        name: 'name',
        title: this.$t('tables.statuses.name'),
        width: '30%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
  },
  // methods: {
  //   getStarMessage (user) {
  //     const actionName = user.starred ? this.$t('tables.unstar') : this.$t('tables.star')
  //     return `${actionName} ${user.fullName}`
  //   },
  //   getStarColor (user) {
  //     return user.starred ? 'primary' : 'gray'
  //   },
  //   star ({ id }) {
  //     const i = this.users.findIndex(user => user.id === id)
  //     this.users[i].starred = !this.users[i].starred
  //   },
  // },
}
</script>

<style lang="scss">
</style>
